import React, { Children, lazy } from 'react';
import { motion } from 'framer-motion';
const galleryImages = [{
  id: 1,
  src: 'https://cdn.magicpatterns.com/uploads/dhBq2b9YSx7LFnn6pD5gFf/unnamed_(1).webp',
  alt: 'Interior de la cueva',
  className: 'col-span-1 md:col-span-2 row-span-2'
}, {
  id: 2,
  src: 'https://cdn.magicpatterns.com/uploads/4o6UMAKuxdcPBdQQTKPVY2/unnamed.webp',
  alt: 'Platos asados',
  className: 'col-span-1 row-span-1'
}, {
  id: 3,
  src: 'https://cdn.magicpatterns.com/uploads/8rd1diyWDqkWkKz1KDziz6/unnamed_(3).webp',
  alt: 'Entrantes',
  className: 'col-span-1 row-span-1'
}, {
  id: 4,
  src: 'https://cdn.magicpatterns.com/uploads/cLFMUeBUcL2pFPsez4kxct/unnamed_(2).webp',
  alt: 'Exterior del restaurante',
  className: 'col-span-1 md:col-span-2 row-span-1'
}, {
  id: 5,
  src: 'https://cdn.magicpatterns.com/uploads/7hg175tSvH6WLHHEfSzx96/unnamed_(2).webp',
  alt: 'Plato principal',
  className: 'col-span-1 row-span-1'
}, {
  id: 6,
  src: 'https://cdn.magicpatterns.com/uploads/dBsk4EmEAXwzaGoajvipap/unnamed_(1).webp',
  alt: 'Postre casero',
  className: 'col-span-1 row-span-1'
}, {
  id: 7,
  src: 'https://cdn.magicpatterns.com/uploads/pbkbBmxXsYim4oV6nNK99m/unnamed_(3).webp',
  alt: 'Detalle de la cueva',
  className: 'col-span-1 md:col-span-2 row-span-1'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function GallerySection() {
  return <section id="galeria" className="py-24 bg-laura-dark text-laura-cream" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="text-center mb-16" data-id="element-120">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-laura-olive text-sm font-bold uppercase tracking-[0.2em] mb-4 block" data-id="element-121">
            Galería
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-playfair mb-8" data-id="element-122">
            Momentos en El Rincón de Laura
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 auto-rows-[200px] md:auto-rows-[250px]" data-id="element-123">
          {galleryImages.map(image => <motion.div key={image.id} variants={itemVariants} className={`relative overflow-hidden rounded-lg group ${image.className}`} data-id="element-124">
              <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10" data-id="element-125" />
              <img src={image.src} alt={image.alt} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700 ease-out" loading="lazy" data-id="element-126" />
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}